import type {TextLinkProps} from '@smart/web-components';
import {TextLink} from '@smart/web-components';
import * as React from 'react';

export type RichtextLinkProps = Omit<TextLinkProps, 'linkText'> & {
  readonly children: string;
};

export function RichtextLink({
  children,
  ...props
}: RichtextLinkProps): JSX.Element {
  return <TextLink linkText={children} target="_blank" {...props} />;
}
